
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artists/[id]/albums/[album_id]",
      function () {
        return require("private-next-pages/artists/[id]/albums/[album_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artists/[id]/albums/[album_id]"])
      });
    }
  